module.exports = __webpack_public_path__ + "static/media/study1.262669f0.jpg";